import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { APP_CONFIG } from './shared/configs/common.config';
import { ToastService, toastMessage } from './shared/services/toast-service.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WsLiveServiceService } from './shared/services/ws-live-service.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, NgbModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public appVersion: string = APP_CONFIG.APP_VERSION;
  public appStatus: string = 'disconnected';

  constructor(
    public toastService: ToastService,
    wsService: WsLiveServiceService
  ) {
    wsService.status.subscribe({
      next: status => {
        this.appStatus = `${status ? 'connected' : 'disconnected'} since ${new Date()}`;
      }
    });
  }
}
